<template>
  <div class="fields flex grow">
    <EditableArea
      v-if="fields"
      class="grid gap-sm"
      :content="fields"
    />
  </div>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';

interface Props {
  fields?: any;
  horizontalPosition?: string;
  verticalPosition?: string;
  margin?: string;
  marginY?: string;
  marginMobile?: string;
  marginMobileY?: string;
}

const props = withDefaults(defineProps<Props>(), {
  fields: undefined,
  horizontalPosition: 'center',
  verticalPosition: 'top',
  margin: '1.5',
  marginY: undefined,
  marginMobile: '1.5',
  marginMobileY: undefined,
});
const numberOfColumns: number = inject('numberOfColumns', 0) ?? 0;

const padding = `${props.margin}rem`;
const paddingY = `${props.marginY ?? props.margin}rem`;

const paddingForMobile = `${props.marginMobile}rem`;
const paddingForMobileY = `${props.marginMobileY ?? props.marginMobile}rem`;
const flexBasis = `${80 / numberOfColumns}%`;
</script>

<style lang="scss" scoped>
.fields {
  text-align: v-bind(horizontalPosition);
  justify-content: v-bind(horizontalPosition);
  align-items: v-bind(verticalPosition);
  padding-left: v-bind(padding);
  padding-right: v-bind(padding);
  padding-top: v-bind(paddingY);
  padding-bottom: v-bind(paddingY);
  flex-basis: v-bind(flexBasis);

  @include for-mobile {
    padding-left: v-bind(paddingForMobile);
    padding-right: v-bind(paddingForMobile);
    padding-top: v-bind(paddingForMobileY);
    padding-bottom: v-bind(paddingForMobileY);
  }

  @include only-mobile {
    flex-basis: unset;
  }
}
</style>
